import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares'
import { SquaresContext } from 'global/wrappers/SquaresWrapper'
import { useContext, useEffect, useMemo, useState } from 'react'
import { Divider, Icon, List, Segment } from 'semantic-ui-react'
import { FormContext } from '../../../cnr/contexts/FormContext'
import { ParentContext } from '../../../cnr/contexts/ParentContext'
import { uniqueKey } from '../../../common/keys'
import { gEnums } from '../../../enums/globalEnums'

const showLogs = false

const DataConstraintList = (props) => {

  const { fip, formItemType } = props ?? {}
  const { propname: prop, value: _value } = fip ?? {}

  // formContext
  const formContext = useContext(FormContext)
  const { form_state, form_handlers } = formContext ?? {}
  const { data_localForm } = form_state ?? {}

  // eventInfoContext  
  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { eventInfo_state } = states
  const { appDataDocuments, staticViews } = eventInfo_state ?? {}

  const _appDataDocuments = appDataDocuments || staticViews


  const squaresContext = useContext(SquaresContext)
  const { squares_state, squares_handlers } = squaresContext ?? {}
  const { handleGo_next } = squares_handlers ?? {}
  const { keyPath, pageView } = squares_state ?? {}

  // get the view for the current pageView
  const _apsView = squares_state?.apsViews?.[pageView]
  const dataConstraints = _.get(_apsView, keyPath, {})
  const { [prop]: dataConstraintList } = dataConstraints ?? {}

  const [queryList, setQueryList] = useState([])
  const [dcProps, setDcProps] = useState({ divider: 'Data Constraints', subKey: prop })

  const _val = useMemo(() => {
    return dataConstraintList || []
  }, [dataConstraintList])

  useEffect(() => {
    if (showLogs) {
      console.group('DataConstraintList')
      console.log('_apsView', pageView, _apsView)
      console.log('props', props)
      console.log('formItemType', formItemType)
      console.log('keyPath', keyPath)
      console.log('dataConstraints', dataConstraints)
      console.log('dataConstraintList', dataConstraintList)
      console.log('_val', _val)
      console.groupEnd()
    }
    if (_.isArray(_val)) {
      setQueryList(_val)
    } else {
      setQueryList([])
    }
    const _dcProps = { divider: 'Data Constraint Items', subKey: prop, isAlt: true }
    switch (formItemType) {
      case gEnums.formItemTypes.dataConstraintList:
        // nothing
        break;
      case gEnums.formItemTypes.appUserDataConstraintList:
        _dcProps.divider = 'App User Data Constraints'
        _dcProps.subKey = 'pageItemConstraints'
        break;
      case gEnums.formItemTypes.pageConstraintList:
        _dcProps.divider = 'Page Constraints'
        _dcProps.subKey = 'pageItemConstraints'
        break;
      default:
      // nothing
    }
    setDcProps(_dcProps)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_val]);

  const sts = (item, index) => {
    // const _item = { key: vsComponentTypes.constraintBuilder, selectedItem: item, selectedIndex: index, formItemType }
    const _item = { key: formItemType, selectedItem: item, selectedIndex: index, formItemType }
    const swipeProps = {
      swipedItem: _item
    }
    // console.group('handleGo_next')
    // console.log('_item', _item)
    // console.log('vsc_state', vsc_state)
    // console.groupEnd()
    handleGo_next(_item)
    // swipeToSelected && swipeToSelected(swipeProps)
  }

  const removeItemByProps = (arr, item) => {
    return _.reject(arr, obj => _.isMatch(obj, item));
  };

  const handleRemove = (e, item) => {
    e.stopPropagation()
    const _list = [...queryList]
    const _listUpdated = removeItemByProps(_list, item)
    const cp = `${squares_state?.pageView}.${squares_state.keyPath}.${prop}`
    console.log('cp', cp, _listUpdated)
    setQueryList(_listUpdated)
    squares_handlers.handleSet_value(_listUpdated, cp)
  }

  const addQueryLine = () => <div className={'line-icon'}>
    <Icon name={'add'} onClick={() => { sts() }} />
  </div>

  const listIz = (mis) => <ItemMenuSquares
    menuItems={mis}
    imsType={_imsTypes.queryList}
    appDataDocuments={_appDataDocuments}
    onRemove={handleRemove}
  />

  const content = () => <div style={{ padding: '0 0 1em 0' }}>
    <Divider key={uniqueKey('fi', 'qb')} horizontal className={dcProps.isAlt ? 'alt' : null}>{dcProps.divider}</Divider>
    {addQueryLine()}
    <Segment basic inverted >
      {queryList && listIz(queryList)}
      {/* {queryList && <List divided relaxed inverted ordered>
        {listItems()}
      </List>} */}
      {!queryList && 'No Items'}
    </Segment>
  </div>

  return content()

}

export default DataConstraintList